<template>
  <div class="login-page">
    <div
      class="login-page__bg"
      :style="{ backgroundImage: 'url(' + bgUrl + ')' }"
    />
    <div class="login-page__sky" aria-hidden="true" />
    <div class="login-page__birds" aria-hidden="true">
      <span class="bird bird--1" />
      <span class="bird bird--2" />
      <span class="bird bird--3" />
    </div>

    <div class="login-shell">
      <header class="brand">
        <div class="brand__icon" aria-hidden="true">
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <polygon points="32,6 58,22 32,38 6,22" fill="#1e7ae8" />
            <polygon points="6,22 32,38 32,58 6,42" fill="#1566c9" />
            <polygon points="32,38 58,22 58,42 32,58" fill="#3d94f0" />
            <line x1="14" y1="26" x2="50" y2="26" stroke="#fff" stroke-width="2.5" stroke-linecap="round" />
            <line x1="14" y1="32" x2="44" y2="32" stroke="rgba(255,255,255,.85)" stroke-width="2" stroke-linecap="round" />
            <line x1="38" y1="28" x2="52" y2="36" stroke="rgba(255,255,255,.75)" stroke-width="2" stroke-linecap="round" />
            <line x1="40" y1="34" x2="54" y2="42" stroke="rgba(255,255,255,.6)" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </div>
        <span class="brand__name">心境</span>
      </header>

      <form class="login-form" @submit.prevent="onSubmit">
        <label class="field">
          <span class="field__icon field__icon--user" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-4 0-7 2-7 4v1h14v-1c0-2-3-4-7-4Z" fill="#fff" />
            </svg>
          </span>
          <input
            v-model.trim="username"
            type="text"
            class="field__input"
            placeholder="请输入用户名"
            autocomplete="username"
          >
        </label>

        <label class="field">
          <span class="field__icon field__icon--lock" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 11V8a5 5 0 1 0-10 0v3H5v10h14V11h-2Zm-2 0H9V8a3 3 0 0 1 6 0v3Z" fill="#fff" />
            </svg>
          </span>
          <input
            v-model="password"
            type="password"
            class="field__input"
            placeholder="请输入密码"
            autocomplete="current-password"
          >
        </label>

        <button type="submit" class="btn-login" :disabled="loading">
          {{ loading ? '登录中…' : '登录' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import loginBg from '@/assets/login-bg.png'
import { login } from '@/api/user'
import { saveUser } from '@/utils/auth'
import message from '@/utils/message'

export default {
  name: 'Login',
  data () {
    return {
      bgUrl: loginBg,
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    async onSubmit () {
      if (!this.username) {
        message.warning('请输入用户名')
        return
      }
      if (!this.password) {
        message.warning('请输入密码')
        return
      }
      if (this.loading) return

      this.loading = true
      try {
        const res = await login({
          account: this.username,
          pwd: this.password
        })

        if (res.status !== 0) {
          message.error(res.msg || '登录失败，请重试')
          return
        }

        saveUser({
          account: this.username,
          userId: res.userId,
          quickCode: res.quickCode,
          token: res.token,
          forceModifyPwd: res.forceModifyPwd,
          functionPack: res.functionPack || []
        })

        if (res.forceModifyPwd === '1') {
          message.warning('登录成功，请尽快修改密码')
        } else {
          message.success('登录成功')
        }

        this.$router.push({ name: 'WorldHome' })
      } catch (err) {
        message.error(err.message || '网络异常，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.login-page__bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center 35%;
  background-repeat: no-repeat;
  transform: scale(1.02);
}

.login-page__sky {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(186, 230, 253, 0.55) 0%,
    rgba(224, 242, 254, 0.15) 38%,
    rgba(255, 255, 255, 0) 62%
  );
}

.login-page__birds {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.bird {
  position: absolute;
  width: 18px;
  height: 6px;
  border-radius: 50%;
  box-shadow: inset 0 -2px 0 0 rgba(30, 80, 120, 0.35);
  background: rgba(40, 90, 130, 0.45);
  transform: rotate(-8deg);
}

.bird--1 {
  top: 14%;
  left: 18%;
  opacity: 0.55;
}

.bird--2 {
  top: 22%;
  right: 22%;
  width: 14px;
  opacity: 0.45;
}

.bird--3 {
  top: 11%;
  right: 12%;
  width: 12px;
  opacity: 0.4;
}

.login-shell {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  padding: 24px 28px 32px;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  user-select: none;
}

.brand__icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  filter: drop-shadow(0 4px 10px rgba(30, 120, 200, 0.25));
}

.brand__icon svg {
  display: block;
  width: 100%;
  height: 100%;
}

.brand__name {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #0f4a8a;
}

.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  align-items: stretch;
  background: #fff;
  border: 1.5px solid #3b8ede;
  border-radius: 999px;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(30, 100, 180, 0.12);
}

.field__icon {
  flex-shrink: 0;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.field__icon--user {
  background: linear-gradient(145deg, #2b8eea, #1a6fd0);
}

.field__icon--lock {
  background: linear-gradient(145deg, #f05252, #d63a3a);
}

.field__input {
  flex: 1;
  border: 0;
  outline: none;
  font-size: 15px;
  padding: 14px 16px 14px 0;
  color: #1e293b;
  background: transparent;
}

.field__input::placeholder {
  color: #94a3b8;
}

.btn-login {
  margin-top: 4px;
  width: 100%;
  border: 0;
  border-radius: 999px;
  padding: 14px 20px;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(180deg, #2b8eea 0%, #1a6fd0 100%);
  box-shadow: 0 10px 28px rgba(26, 111, 208, 0.38);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.btn-login:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 32px rgba(26, 111, 208, 0.45);
}

.btn-login:active {
  transform: translateY(0);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue